import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Lock, Trophy, ArrowRight, Banknote, Gift, Medal, Building, BarChart3, Sparkles, Phone } from 'lucide-react';
import { getLeaderboardData } from '../data/leaderboardData';
import { MOCK_COMMISSIONS } from '../data/mockData';
// === R ZONE DATA ===
const LEADS_METRICS = [{
  label: 'All New Leads',
  value: '5K',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Leads Ready to Pitch',
  value: '21',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Docs Out Today',
  value: '19',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Submitted to UW Today',
  value: '16',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Count of Leads in Call List',
  value: '440',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Pitch Accepted Waiting on Docs',
  value: '33',
  sub: 'As of Feb 17, 2026, 3:03 PM',
  isAlert: true
}, {
  label: 'Docs Out This Week',
  value: '92',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Submitted to UW This Week',
  value: '48',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Leads With Call Backs',
  value: '1.6K',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Docs Out This Month',
  value: '266',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}, {
  label: 'Submitted to UW This Month',
  value: '155',
  sub: 'As of Feb 17, 2026, 3:03 PM'
}];
const ORIGINATION_DATA = [{
  label: 'Pre-Set Up',
  value: 34,
  max: 100
}, {
  label: 'ReWork',
  value: 29,
  max: 100
}, {
  label: 'Set Up',
  value: 6,
  max: 100
}, {
  label: 'Docs Out',
  value: 90,
  max: 100
}, {
  label: 'DRI',
  value: 48,
  max: 100
}];
const UW_DATA = [{
  label: 'Underwriting',
  value: 25,
  max: 280
}, {
  label: 'AWC',
  value: 261,
  max: 280
}, {
  label: 'Resubmitted',
  value: 12,
  max: 280
}, {
  label: 'Suspended',
  value: 1,
  max: 280
}];
const CLOSING_DATA = [{
  label: 'CTC',
  value: 17,
  max: 20
}];
const CALENDAR_EVENTS = [{
  day: 2,
  count: 6,
  items: ['CHRISTOPHER LIES', 'George Lewis']
}, {
  day: 3,
  count: 8,
  items: ['Adam Long', 'Antoine Smith']
}, {
  day: 4,
  count: 4,
  items: ['CLIFFORD GARRISON', 'Danny Cooper']
}, {
  day: 5,
  count: 3,
  items: ['David Perry', 'John Pavlik']
}, {
  day: 6,
  count: 1,
  items: ['JULIE POLSENO']
}, {
  day: 7,
  count: 3,
  items: ['Erika Sims', 'JERRY WILLIAMSON']
}, {
  day: 9,
  count: 8,
  items: ['Arthur Russell', 'HERIBERTO cuevas']
}, {
  day: 10,
  count: 10,
  items: ['ANNE COLE', 'Armon Wade']
}, {
  day: 11,
  count: 4,
  items: ['Cody Bird', 'Daniel Graham']
}, {
  day: 12,
  count: 4,
  items: ['BRADFORD KIMBALL', 'Dona Bouchard']
}, {
  day: 13,
  count: 8,
  items: ['Donald Wagaman', 'Eric Boisvert']
}, {
  day: 14,
  count: 5,
  items: ['Carolyn Davis', 'Chris Lupkes']
}, {
  day: 16,
  count: 4,
  items: ['DANIEL RANGEL', 'Fredrick Sharpless']
}, {
  day: 17,
  count: 10,
  items: ['ANTHONY DEPARDO', 'David Guzman']
}, {
  day: 18,
  count: 4,
  items: ['Evaughn Davis', 'Janet Bingham']
}, {
  day: 20,
  count: 3,
  items: ['Boyd Coots', 'Clarence Fleck']
}, {
  day: 21,
  count: 3,
  items: ['Robert Fenzel', 'ROCKY PRICE']
}, {
  day: 27,
  count: 1,
  items: ['VIRGIL SCHWAB']
}];
const CLOSING_LOANS = [{
  name: 'CHRISTOPHER LIES',
  id: '1526025846',
  amount: '$376,800',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'George Lewis',
  id: '1526017775',
  amount: '$172,975',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'GINA CRAIG',
  id: '1525393157',
  amount: '$359,450',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'PAGE GRIFFIN',
  id: '1526025874',
  amount: '$314,200',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'Warren Sanders',
  id: '1526024347',
  amount: '$167,700',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'William Sears',
  id: '1525424814',
  amount: '$283,000',
  date: '2/2/2026',
  status: 'Funded' as const
}, {
  name: 'Adam Long',
  id: '1526007588',
  amount: '$381,562',
  date: '2/3/2026',
  status: 'Funded' as const
}, {
  name: 'Antoine Smith',
  id: '1525434878',
  amount: '$462,000',
  date: '2/3/2026',
  status: 'Funded' as const
}, {
  name: 'Bernett Hairston',
  id: '1526009472',
  amount: '$105,000',
  date: '2/3/2026',
  status: 'Funded' as const
}, {
  name: 'Bobby Williams',
  id: 'EN0000954698',
  amount: '$246,393',
  date: '2/3/2026',
  status: 'Closing' as const
}];
function BarChartCard({
  title,
  data,
  colorClass = 'bg-blue-500'
}: {
  title: string;
  data: {
    label: string;
    value: number;
    max: number;
  }[];
  colorClass?: string;
}) {
  return <div className="bg-navy-900/80 border border-white/10 rounded-xl p-4 flex flex-col h-full" data-id="element-1248">
      <div className="flex justify-between items-start mb-4" data-id="element-1249">
        <h3 className="text-white font-bold text-sm" data-id="element-1250">{title}</h3>
        <div className="flex gap-2" data-id="element-1251">
          <div className="w-4 h-4 rounded-full border border-white/20 flex items-center justify-center cursor-pointer hover:bg-white/5" data-id="element-1252">
            <span className="text-[10px] text-white" data-id="element-1253">↻</span>
          </div>
          <div className="w-4 h-4 rounded-full border border-white/20 flex items-center justify-center cursor-pointer hover:bg-white/5" data-id="element-1254">
            <span className="text-[10px] text-white" data-id="element-1255">⤢</span>
          </div>
        </div>
      </div>
      <div className="flex-1 space-y-3" data-id="element-1256">
        <div className="flex justify-end text-[10px] text-slate-400 mb-1 px-2" data-id="element-1257">
          <span data-id="element-1258">Record Count</span>
        </div>
        {data.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-xs" data-id="element-1259">
            <div className="w-24 text-right text-slate-300 font-medium shrink-0" data-id="element-1260">
              {item.label}
            </div>
            <div className="flex-1 relative h-5 bg-navy-800/50 rounded-sm overflow-hidden" data-id="element-1261">
              <div className="absolute inset-0 flex justify-between px-1" data-id="element-1262">
                {[0, 1, 2, 3, 4].map(i => <div key={i} className="h-full w-px bg-white/5" data-id="element-1263" />)}
              </div>
              <motion.div initial={{
            width: 0
          }} animate={{
            width: `${item.value / item.max * 100}%`
          }} transition={{
            duration: 1,
            delay: 0.2 + idx * 0.1
          }} className={`h-full ${colorClass} flex items-center justify-end px-1 relative z-10`} data-id="element-1264">
                <span className="text-[10px] font-bold text-white drop-shadow-md" data-id="element-1265">
                  {item.value}
                </span>
              </motion.div>
            </div>
          </div>)}
      </div>
      <div className="mt-4 flex justify-between items-end" data-id="element-1266">
        <button className="text-[10px] text-accent-400 hover:underline" data-id="element-1267">
          View Report ({title})
        </button>
        <span className="text-[10px] text-slate-500" data-id="element-1268">
          As of Feb 17, 2026, 3:03 PM
        </span>
      </div>
    </div>;
}
function MetricCard({
  item,
  index
}: {
  item: {
    label: string;
    value: string;
    sub: string;
    isAlert?: boolean;
  };
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.05
  }} whileHover={{
    y: -3,
    boxShadow: '0 8px 25px -5px rgba(0,0,0,0.4), 0 0 10px rgba(56,189,248,0.08)'
  }} className="bg-navy-800/70 border border-white/5 rounded-xl p-4 flex flex-col justify-between h-32 relative group hover:bg-navy-800/90 hover:border-accent-400/10 transition-colors" data-id="element-1269">
      <div className="flex justify-between items-start" data-id="element-1270">
        <h3 className="text-slate-300 text-xs font-medium line-clamp-2" data-id="element-1271">
          {item.label}
        </h3>
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1272">
          <div className="w-3 h-3 rounded-full border border-white/20 flex items-center justify-center cursor-pointer hover:bg-white/5" data-id="element-1273">
            <span className="text-[8px] text-slate-400" data-id="element-1274">↻</span>
          </div>
          <div className="w-3 h-3 rounded-full border border-white/20 flex items-center justify-center cursor-pointer hover:bg-white/5" data-id="element-1275">
            <span className="text-[8px] text-slate-400" data-id="element-1276">⤢</span>
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center" data-id="element-1277">
        <span className={`text-4xl font-bold ${item.isAlert ? 'text-red-400' : 'text-white'}`} data-id="element-1278">
          {item.value}
        </span>
      </div>
      <div className="flex justify-between items-end mt-2" data-id="element-1279">
        <button className="text-[10px] text-accent-400 font-medium hover:underline" data-id="element-1280">
          View Report
        </button>
        <span className="text-[9px] text-slate-500 max-w-[100px] text-right leading-tight" data-id="element-1281">
          {item.sub}
        </span>
      </div>
    </motion.div>;
}
interface RZoneViewProps {
  onNavigate: (tab: 'rzone' | 'leaderboard' | 'commission' | 'rewards') => void;
}
export function RZoneView({
  onNavigate
}: RZoneViewProps) {
  const [activeDashboard, setActiveDashboard] = useState<'company' | 'performance'>('company');
  const leaderboardData = getLeaderboardData('company', 'volume', 'this_month');
  const currentUserData = leaderboardData.find(entry => entry.name === 'Katrina Bullock');
  const topProducer = leaderboardData[0];
  const currentUserCommission = MOCK_COMMISSIONS[0];
  return <div className="max-w-[1600px] mx-auto p-4 space-y-6" data-id="element-1282">
      {/* Hero Section - Welcome */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center mb-2" data-id="element-1283">
        <h1 className="text-4xl font-extrabold gradient-text mb-2" data-id="element-1284">
          Welcome back, Katrina 👋
        </h1>
        <p className="text-slate-400 text-sm" data-id="element-1285">
          Your command center is ready — let's close some deals
        </p>
      </motion.div>

      {/* Quick Stats Row - 3 Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1286">
        {/* Commission Preview Card */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="glass-card-emerald rounded-xl shadow-sm p-5 relative overflow-hidden group cursor-pointer hover-lift shimmer-on-hover" whileHover={{}} onClick={() => onNavigate('commission')} data-id="element-1287">
          <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-500/5 rounded-full blur-2xl pointer-events-none" data-id="element-1288" />
          <div className="relative z-10" data-id="element-1289">
            <div className="flex items-center justify-between mb-4" data-id="element-1290">
              <div className="flex items-center gap-2" data-id="element-1291">
                <div className="p-2 rounded-lg bg-emerald-500/10 border border-emerald-500/20" data-id="element-1292">
                  <Banknote size={18} className="text-emerald-400" data-id="element-1293" />
                </div>
                <h3 className="text-sm font-bold text-white" data-id="element-1294">
                  Commission Center
                </h3>
              </div>
              <Lock size={14} className="text-amber-400" data-id="element-1295" />
            </div>
            <div className="space-y-2 mb-4" data-id="element-1296">
              <div className="flex justify-between items-center" data-id="element-1297">
                <span className="text-xs text-slate-400" data-id="element-1298">Period</span>
                <span className="text-sm font-semibold text-white" data-id="element-1299">
                  {currentUserCommission.payPeriod}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1300">
                <span className="text-xs text-slate-400" data-id="element-1301">Units Closed</span>
                <span className="text-sm font-semibold text-white" data-id="element-1302">
                  {currentUserCommission.units}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1303">
                <span className="text-xs text-slate-400" data-id="element-1304">Badge</span>
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/10 text-amber-400 text-xs font-bold border border-amber-500/20" data-id="element-1305">
                  <Medal size={12} data-id="element-1306" />
                  {currentUserCommission.profile?.badge}
                </span>
              </div>
            </div>
            <button className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold transition-colors" data-id="element-1307">
              View Details <Lock size={12} data-id="element-1308" />
            </button>
          </div>
        </motion.div>

        {/* Leaderboard Ranking Card */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="glass-card-cyan rounded-xl shadow-sm p-5 relative overflow-hidden group cursor-pointer hover-lift shimmer-on-hover" whileHover={{}} onClick={() => onNavigate('leaderboard')} data-id="element-1309">
          <div className="absolute top-0 right-0 w-32 h-32 bg-accent-400/5 rounded-full blur-2xl pointer-events-none" data-id="element-1310" />
          <div className="relative z-10" data-id="element-1311">
            <div className="flex items-center justify-between mb-4" data-id="element-1312">
              <div className="flex items-center gap-2" data-id="element-1313">
                <div className="p-2 rounded-lg bg-accent-400/10 border border-accent-400/20" data-id="element-1314">
                  <Trophy size={18} className="text-accent-400" data-id="element-1315" />
                </div>
                <h3 className="text-sm font-bold text-white" data-id="element-1316">Your Ranking</h3>
              </div>
            </div>
            {currentUserData ? <>
                <div className="mb-4" data-id="element-1317">
                  <div className="flex items-baseline gap-2 mb-1" data-id="element-1318">
                    <span className="text-3xl font-bold value-glow-cyan" data-id="element-1319">
                      #{currentUserData.rank}
                    </span>
                    <span className="text-sm text-slate-400" data-id="element-1320">
                      of {leaderboardData.length}
                    </span>
                  </div>
                  <p className="text-xs text-slate-500" data-id="element-1321">Company-wide ranking</p>
                </div>
                <div className="p-3 rounded-lg bg-navy-900/50 border border-white/[0.02] mb-4" data-id="element-1322">
                  <p className="text-[10px] text-slate-500 mb-1" data-id="element-1323">
                    Top Producer
                  </p>
                  <div className="flex items-center justify-between" data-id="element-1324">
                    <span className="text-sm font-semibold text-white" data-id="element-1325">
                      {topProducer.name}
                    </span>
                    <span className="text-sm font-bold text-accent-400" data-id="element-1326">
                      ${(topProducer.value / 1000000).toFixed(1)}M
                    </span>
                  </div>
                </div>
              </> : <div className="mb-4 text-center py-4" data-id="element-1327">
                <p className="text-sm text-slate-400" data-id="element-1328">
                  No ranking data available
                </p>
              </div>}
            <button className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-accent-600 hover:bg-accent-700 text-white text-xs font-semibold transition-colors" data-id="element-1329">
              View Leaderboard <ArrowRight size={12} data-id="element-1330" />
            </button>
          </div>
        </motion.div>

        {/* Reward Center Card (Coming Soon) */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="glass-card-purple rounded-xl shadow-sm p-5 relative overflow-hidden hover-lift" data-id="element-1331">
          <div className="absolute top-0 right-0 w-32 h-32 bg-purple-500/5 rounded-full blur-2xl pointer-events-none" data-id="element-1332" />
          <motion.div animate={{
          rotate: [0, 5, -5, 0]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-2 right-2" data-id="element-1333">
            <Sparkles size={16} className="text-purple-400" data-id="element-1334" />
          </motion.div>
          <div className="relative z-10" data-id="element-1335">
            <div className="flex items-center justify-between mb-4" data-id="element-1336">
              <div className="flex items-center gap-2" data-id="element-1337">
                <div className="p-2 rounded-lg bg-purple-500/10 border border-purple-500/20" data-id="element-1338">
                  <Gift size={18} className="text-purple-400" data-id="element-1339" />
                </div>
                <h3 className="text-sm font-bold text-white" data-id="element-1340">Reward Center</h3>
              </div>
              <span className="px-2 py-0.5 rounded-full bg-purple-500/10 text-purple-400 text-[10px] font-bold border border-purple-500/20" data-id="element-1341">
                COMING SOON
              </span>
            </div>
            <p className="text-xs text-slate-400 mb-4 leading-relaxed" data-id="element-1342">
              Earn points for every closed loan and redeem for exclusive rewards
            </p>
            <div className="space-y-2 mb-4" data-id="element-1343">
              <div className="flex justify-between items-center" data-id="element-1344">
                <span className="text-xs text-slate-500" data-id="element-1345">Points Earned</span>
                <span className="text-sm font-semibold text-slate-400" data-id="element-1346">
                  0 pts
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1347">
                <span className="text-xs text-slate-500" data-id="element-1348">
                  Rewards Available
                </span>
                <span className="text-sm font-semibold text-slate-400" data-id="element-1349">0</span>
              </div>
            </div>
            <button disabled className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-slate-700 text-slate-500 text-xs font-semibold cursor-not-allowed" data-id="element-1350">
              Coming Soon
            </button>
          </div>
        </motion.div>
      </div>

      {/* Dashboard Container with Tab Switcher */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-navy-800/70 rounded-2xl border border-white/5 shadow-lg overflow-hidden" data-id="element-1351">
        {/* Tab Bar */}
        <div className="border-b border-white/5 px-6 pt-4 bg-navy-900/50" data-id="element-1352">
          <div className="flex gap-1" data-id="element-1353">
            <button onClick={() => setActiveDashboard('company')} className={`relative px-4 py-3 text-sm font-semibold rounded-t-lg transition-colors ${activeDashboard === 'company' ? 'text-accent-400' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-1354">
              {activeDashboard === 'company' && <motion.div layoutId="dashboardTab" className="absolute inset-0 bg-navy-800 rounded-t-lg border-t border-l border-r border-white/10" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-1355" />}
              <span className="relative z-10 flex items-center gap-2" data-id="element-1356">
                <Building size={16} data-id="element-1357" />
                Company Dashboard
              </span>
            </button>
            <button onClick={() => setActiveDashboard('performance')} className={`relative px-4 py-3 text-sm font-semibold rounded-t-lg transition-colors ${activeDashboard === 'performance' ? 'text-accent-400' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-1358">
              {activeDashboard === 'performance' && <motion.div layoutId="dashboardTab" className="absolute inset-0 bg-navy-800 rounded-t-lg border-t border-l border-r border-white/10" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-1359" />}
              <span className="relative z-10 flex items-center gap-2" data-id="element-1360">
                <BarChart3 size={16} data-id="element-1361" />
                Performance Statistics
              </span>
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-6" data-id="element-1362">
          <AnimatePresence mode="wait" data-id="element-1363">
            {activeDashboard === 'company' && <motion.div key="company" initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 20
          }} transition={{
            duration: 0.2
          }} data-id="element-1364">
                <div className="flex flex-col lg:flex-row gap-4" data-id="element-1365">
                  {/* Left Column - Leads */}
                  <div className="flex-1 lg:flex-[3] space-y-4" data-id="element-1366">
                    <div className="bg-navy-900/50 rounded-xl p-3 border border-white/5 flex justify-center" data-id="element-1367">
                      <h2 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-1368">
                        Leads <Phone size={20} data-id="element-1369" />
                      </h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-1370">
                      {LEADS_METRICS.map((item, i) => <MetricCard key={item.label} item={item} index={i} data-id="element-1371" />)}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1372">
                      <div className="bg-navy-900/50 rounded-xl p-4 border border-white/5 min-h-[100px] flex flex-col justify-center items-center" data-id="element-1373">
                        <h3 className="text-white font-bold text-base mb-2" data-id="element-1374">
                          UNQUALIFIED LEADS
                        </h3>
                        <div className="w-8 h-1 bg-amber-400/50 rounded-full" data-id="element-1375" />
                      </div>
                      <div className="bg-navy-900/50 rounded-xl p-4 border border-white/5 min-h-[100px] flex flex-col justify-center items-center" data-id="element-1376">
                        <h3 className="text-white font-bold text-base mb-2 flex items-center gap-2" data-id="element-1377">
                          WITHDRAWN LOANS <span data-id="element-1378">📥</span>
                        </h3>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Loans */}
                  <div className="flex-1 lg:flex-[2] space-y-4" data-id="element-1379">
                    <div className="bg-navy-900/50 rounded-xl p-3 border border-white/5 flex justify-center" data-id="element-1380">
                      <h2 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-1381">
                        Loans <span className="text-xl" data-id="element-1382">🏦</span>
                      </h2>
                    </div>
                    <div className="space-y-3" data-id="element-1383">
                      <BarChartCard title="Loans In Origination" data={ORIGINATION_DATA} colorClass="bg-blue-500" data-id="element-1384" />
                      <BarChartCard title="Loans In UW" data={UW_DATA} colorClass="bg-blue-500" data-id="element-1385" />
                      <BarChartCard title="Loans in Closing" data={CLOSING_DATA} colorClass="bg-blue-500" data-id="element-1386" />
                    </div>
                  </div>
                </div>
              </motion.div>}

            {activeDashboard === 'performance' && <motion.div key="performance" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.2
          }} className="space-y-6" data-id="element-1387">
                {/* Performance Statistics */}
                <div data-id="element-1388">
                  <div className="mb-4" data-id="element-1389">
                    <h2 className="text-xl font-bold text-white" data-id="element-1390">
                      Rapid Performance Statistics
                    </h2>
                    <p className="text-xs text-slate-400 mt-1" data-id="element-1391">
                      As of Feb 17, 2026, 3:03 PM
                    </p>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1392">
                    <MetricCard item={{
                  label: 'Docs Out Today',
                  value: '21',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={0} data-id="element-1393" />
                    <MetricCard item={{
                  label: 'Submitted to UW Today',
                  value: '16',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={1} data-id="element-1394" />
                    <MetricCard item={{
                  label: 'CTC Today',
                  value: '5',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={2} data-id="element-1395" />
                    <MetricCard item={{
                  label: 'Currently in Setup',
                  value: '2',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={3} data-id="element-1396" />
                    <MetricCard item={{
                  label: 'Docs Out Yesterday',
                  value: '37',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={4} data-id="element-1397" />
                    <MetricCard item={{
                  label: 'Submitted to UW Yesterday',
                  value: '25',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={5} data-id="element-1398" />
                    <MetricCard item={{
                  label: 'CTC Yesterday',
                  value: '12',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={6} data-id="element-1399" />
                    <div className="hidden lg:block" data-id="element-1400" />
                    <MetricCard item={{
                  label: 'Docs Out This Week',
                  value: '166',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={7} data-id="element-1401" />
                    <MetricCard item={{
                  label: 'Submitted to UW This Week',
                  value: '99',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={8} data-id="element-1402" />
                    <MetricCard item={{
                  label: 'CTC This Week',
                  value: '36',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={9} data-id="element-1403" />
                    <div className="hidden lg:block" data-id="element-1404" />
                    <MetricCard item={{
                  label: 'Docs Out Last Week',
                  value: '158',
                  sub: 'As of Feb 13, 2026, 5:45 PM'
                }} index={10} data-id="element-1405" />
                    <MetricCard item={{
                  label: 'Submitted to UW Last Week',
                  value: '76',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={11} data-id="element-1406" />
                    <MetricCard item={{
                  label: 'CTC Last Week',
                  value: '31',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={12} data-id="element-1407" />
                    <div className="hidden lg:block" data-id="element-1408" />
                    <MetricCard item={{
                  label: 'Docs Out This Month',
                  value: '324',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={13} data-id="element-1409" />
                    <MetricCard item={{
                  label: 'Submitted to UW This Month',
                  value: '175',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={14} data-id="element-1410" />
                    <MetricCard item={{
                  label: 'CTC This Month',
                  value: '88',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={15} data-id="element-1411" />
                    <div className="hidden lg:block" data-id="element-1412" />
                    <MetricCard item={{
                  label: 'Docs Out Last Month',
                  value: '552',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={16} data-id="element-1413" />
                    <MetricCard item={{
                  label: 'Submitted to UW Last Month',
                  value: '382',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={17} data-id="element-1414" />
                    <MetricCard item={{
                  label: 'CTC Last Month',
                  value: '159',
                  sub: 'As of Feb 13, 2026, 5:46 PM'
                }} index={18} data-id="element-1415" />
                    <div className="hidden lg:block" data-id="element-1416" />
                  </div>
                </div>

                {/* Closing Calendar */}
                <div className="flex flex-col lg:flex-row gap-4" data-id="element-1417">
                  <div className="flex-1 lg:flex-[3] bg-navy-900/50 rounded-xl border border-white/5 overflow-hidden" data-id="element-1418">
                    <div className="p-4 border-b border-white/5 flex items-center justify-between" data-id="element-1419">
                      <div className="flex items-center gap-1" data-id="element-1420">
                        <button className="p-1 hover:bg-white/5 rounded-lg transition-colors" data-id="element-1421">
                          <ChevronLeft size={20} className="text-slate-400" data-id="element-1422" />
                        </button>
                        <h2 className="text-lg font-bold text-white px-2" data-id="element-1423">
                          February 2026
                        </h2>
                        <button className="p-1 hover:bg-white/5 rounded-lg transition-colors" data-id="element-1424">
                          <ChevronRight size={20} className="text-slate-400" data-id="element-1425" />
                        </button>
                      </div>
                      <div className="flex items-center gap-6" data-id="element-1426">
                        <div className="text-right hidden sm:block" data-id="element-1427">
                          <p className="text-xs text-slate-400" data-id="element-1428">
                            Total Closings
                          </p>
                          <p className="text-sm font-bold text-white" data-id="element-1429">89</p>
                        </div>
                        <div className="text-right hidden sm:block" data-id="element-1430">
                          <p className="text-xs text-slate-400" data-id="element-1431">Total Amount</p>
                          <p className="text-sm font-bold text-emerald-400" data-id="element-1432">
                            $24,558,298.00
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-7 border-b border-white/5" data-id="element-1433">
                      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => <div key={day} className="p-2 text-center text-xs font-semibold text-slate-500 border-r border-white/5 last:border-r-0" data-id="element-1434">
                            {day}
                          </div>)}
                    </div>
                    <div className="grid grid-cols-7 auto-rows-fr bg-navy-950/40" data-id="element-1435">
                      {Array.from({
                    length: 28
                  }).map((_, i) => {
                    const day = i + 1;
                    const isToday = day === 17;
                    const events = CALENDAR_EVENTS.find(e => e.day === day);
                    return <div key={day} className={`min-h-[100px] p-2 border-b border-r border-white/5 last:border-r-0 relative ${isToday ? 'bg-amber-500/10' : ''}`} data-id="element-1436">
                            <div className="flex justify-between items-start mb-1" data-id="element-1437">
                              <span className={`text-xs font-medium ${isToday ? 'text-amber-400' : 'text-slate-400'}`} data-id="element-1438">
                                {day}
                              </span>
                              {events && <span className="text-[10px] font-bold bg-white/10 text-white px-1.5 rounded" data-id="element-1439">
                                  {events.count}
                                </span>}
                            </div>
                            <div className="space-y-1" data-id="element-1440">
                              {events?.items.map((item, idx) => <div key={idx} className="text-[9px] p-1 rounded bg-navy-800/80 border border-white/5 text-slate-300 truncate" data-id="element-1441">
                                  {item}
                                </div>)}
                              {events && events.count > 2 && <div className="text-[9px] text-slate-500 text-center" data-id="element-1442">
                                  + {events.count - 2} more
                                </div>}
                            </div>
                          </div>;
                  })}
                    </div>
                  </div>

                  <div className="flex-1 lg:flex-[1] bg-navy-900/50 rounded-xl border border-white/5 flex flex-col overflow-hidden h-[600px]" data-id="element-1443">
                    <div className="p-4 border-b border-white/5" data-id="element-1444">
                      <h3 className="text-white font-bold text-sm" data-id="element-1445">
                        Loans Closing This Month
                      </h3>
                    </div>
                    <div className="overflow-y-auto p-2 space-y-2" data-id="element-1446">
                      {CLOSING_LOANS.map((loan, i) => <div key={i} className="p-3 rounded-lg bg-navy-950/40 border border-white/5" data-id="element-1447">
                          <div className="flex justify-between items-start mb-1" data-id="element-1448">
                            <p className="text-xs font-bold text-white truncate max-w-[140px]" data-id="element-1449">
                              {loan.name}
                            </p>
                            <span className={`text-[9px] px-1.5 py-0.5 rounded ${loan.status === 'Funded' ? 'bg-emerald-500/20 text-emerald-400' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-1450">
                              {loan.status}
                            </span>
                          </div>
                          <p className="text-[10px] text-slate-500 mb-1" data-id="element-1451">
                            ID: {loan.id}
                          </p>
                          <div className="flex justify-between items-center text-[10px]" data-id="element-1452">
                            <span className="text-slate-300" data-id="element-1453">
                              {loan.amount}
                            </span>
                            <span className="text-slate-500" data-id="element-1454">{loan.date}</span>
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>;
}